import React from "react";
import "./hub-rake-ht-master.styles.css";
import { Component } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectUserData, selectMSMessageRBAC } from "../../redux/user/user.selectors";
import { canUserEdit, getUserMSRBACMessage } from "../../auth/utils";
import { FeatureCodes } from "../../auth/data";
// import CustomFilterMultiselect from "../../components/custom-multi-select/custom-multi-select.component";

import {
  Table,
  Spin,
  Input,
  Select,
  Button,
  message,
  Modal,
  Form,
  Radio,
} from "antd";

import CustomSelectSummary from "../../components/custom-select-summary/custom-select-summary.component";

import API from "../../api";

const { Search } = Input;
const { Option } = Select;

class HubRakeHTMaster extends Component {
  state = {
    isModalVisible: false,
    isAdd: false,
    searchText: null,
    searchUserType: 0,
    hubFactoryTableData: [],
    isSubmitted: false,
    primaryHubList: [],
    filteredHubList: [],
    isSpinnerOnLoad: false,
    newData: {
      Hub_Name: "",
      hub_id: undefined,
      hub_ht_cost: "",
      fois_origin_station_code: undefined,
      status: false,
      isEdit: false,
    },
    rowData: undefined,
    selectedHubValue: undefined,
    selectedHubName: "",
  };

  componentDidMount() {
    this.setState({ isSpinnerOnLoad: true });
    // this.getbranchList();
    this.getHubList();
  }

  getMasterHub = async () => {
    this.setState({ isSpinnerOnLoad: true });

    await API.get("/hub_ht")
      .then((response) => {
        this.setState({
          hubFactoryTableData: response.data.data,
          isSpinnerOnLoad: false,
          isAdd: true,
        });

      })
      .catch((err) => {
        if (err) {

          if (err.response && err.response.status === 400)
            message.error("Something went wrong. Please try again later.", 5);
          else {
            message.error("Something went wrong.. Please try again later.", 5);
          }
        } else {
          message.error("Something went wrong... Please try again later.", 5);
        }
        this.setState({ isSpinnerOnLoad: false });
      });

  };

  getHubList = async () => {
    this.setState({ isSpinnerOnLoad: true });

    await API.get("/list_hubs")
      .then((mandiBranch) => {
        // let modifiedData = [...mandiBranch.data.data];
        // modifiedData.push({ branch_id: null, branch_name: "All" });
        const filterhub = mandiBranch.data.data.filter((hubItem) => hubItem.parent_id === this.state.selectedBranchValue);
        this.setState(
          {
            primaryHubList: mandiBranch.data.data,
            filteredHubList: filterhub,
            selectedHubValue: filterhub[0] ? filterhub[0].territory_id : 0,
            selectedHubName: filterhub[0] ? filterhub[0].territory_name : 0,
          },

          () => this.getMasterHub()
        );
      })
      .catch((err) => {
        this.setState({ isSpinnerOnLoad: false });
        if (err) {
          if (err.response && err.response.status === 400)
            message.error("Something went wrong. Please try again later.", 5);
          else {
            message.error("Something went wrong.. Please try again later.", 5);
          }
        } else {
          message.error("Something went wrong... Please try again later.", 5);
        }
      });
  };

  setTableData = () => {
    if (
      this.state.hubFactoryTableData !== undefined &&
      this.state.hubFactoryTableData.length > 0
    ) {

      const userTableData = this.state.hubFactoryTableData.map((user, index) => {
        return {
          key: index,
          Hub_Name: user.Hub_Name,
          hub_id: user.hub_id,
          isEdit: user.isEdit,
          fois_origin_station_code: user.fois_origin_station_code,
          hub_ht_cost: user.hub_ht_cost,
          status: user.status,
          update: true,
        };
      });


      let dataAfterSearch = userTableData;

      if (this.state.searchText) {
        dataAfterSearch = dataAfterSearch.filter(
          (item) =>
            (item.Hub_Name !== null &&
              item.Hub_Name
                .toLowerCase()
                .includes(this.state.searchText.toLowerCase())) ||
            (item.fois_origin_station_code !== null &&
              item.fois_origin_station_code
                .toLowerCase()
                .includes(this.state.searchText.toLowerCase()))
        );
      }

      return dataAfterSearch;
    } else {
      return this.state.hubFactoryTableData;
    }
  };



  submitTableRowData = (row, isPopup) => {
    this.setState({ isSpinnerOnLoad: true, isSubmitted: true });
    let warningmessage = "";
    if (
      row.Hub_Name === null ||
      row.Hub_Name === undefined ||
      row.Hub_Name === ""
    ) {
      warningmessage = "Please Select hub";
    } else if (
      row.fois_origin_station_code === null ||
      row.fois_origin_station_code === undefined ||
      row.fois_origin_station_code === ""
    ) {
      warningmessage = "Please select FOIS Origin Station Code";
    } else if (
      row.hub_ht_cost === null ||
      row.hub_ht_cost === undefined ||
      row.hub_ht_cost === ""
    ) {
      warningmessage = "Please select Hub Rake H&T Cost (₹/MT)";
    }

    if (
      warningmessage === "" ||
      warningmessage === undefined ||
      warningmessage === null
    ) {
      this.setState({ isSubmitted: true });
      this.setState({ isSpinnerOnLoad: true });
      let data = {
        Hub_Name: row.Hub_Name,
        hub_id: row.hub_id,
        fois_origin_station_code: row.fois_origin_station_code,
        hub_ht_cost: row.hub_ht_cost,
        status: row.status,
        update: row.update,
      };

      API.put("/hub_ht", data, {

      })
        .then((response) => {

          if (response.status === 200 && response.data.status) {
            this.setModalVisibility(false);
            message.info(response.data.message, 5);
            this.getMasterHub();
            this.setState({ isSpinnerOnLoad: false, isSubmitted: false });
          } else if (!response.data.status) {
            this.setState({ isSpinnerOnLoad: false, isSubmitted: false });
            message.error(response.data.message, 5);
            // this.setModalVisibility(false);
          } else {
            this.setState({ isSpinnerOnLoad: false, isSubmitted: false });
            message.error("Please try again", 5);
          }
        })
        .catch((err) => {
          if (err) {
            if (err.response && err.response.data.message)
              message.error(err.response.data.message, 5);
            else if (err.response && err.response.status === 400)
              message.error("Something went wrong. Please try again later.", 5);
            else {
              message.error(
                "Something went wrong.. Please try again later.",
                5
              );
            }
          } else {
            message.error("Something went wrong... Please try again later.", 5);
          }
          this.setState({ isSpinnerOnLoad: false, isSubmitted: false });
          // this.setModalVisibility(false);
        });
    } else {
      this.setState({ isSpinnerOnLoad: false, isSubmitted: false });
      message.error(warningmessage, 5);
    }
  };

  TableColumnHeader = (props) => {
    const { title, subtitle } = props;
    return (
      <div className="column-header-container">
        <div
          style={{
            color: "white",
            fontSize: "12px",
            whiteSpace: "nowrap",
            fontWeight: "normal",
            textAlign: "left",
          }}
        >
          {title}
        </div>
        <div
          style={{
            color: "#cbdfff",
            fontSize: "11px",
            fontWeight: "normal",
            textAlign: "left",
            // subtitle && title.length < subtitle.length ? "left" : "center"
          }}
        >
          {subtitle}
        </div>
      </div>
    );
  };

  createFilters = (label) => {
    let filterData = this.state.hubFactoryTableData;
    //#region remove duplicate objects
    let uniqueFilterData = [];
    if (label === "status" && this.state.hubFactoryTableData && this.state.hubFactoryTableData.length > 0) {
      uniqueFilterData = [{ text: "Active", value: 1 }, { text: "Inactive", value: 0 }]
    }
    else {
      filterData.map((mainItem) =>
        uniqueFilterData.filter((item) => item[label] === mainItem[label])
          .length > 0
          ? null
          : uniqueFilterData.push(mainItem)
      );

      uniqueFilterData = uniqueFilterData.map((item) => {
        return {
          text: item[label],
          value: item[label],
        };
      });
      // uniqueFilterData.sort((a, b) => a.text.localeCompare(b.text))
    }

    return uniqueFilterData;
  };

  setModalVisibility = (status) => {
    if (status) {
      const nData = {
        Hub_Name: "",
        hub_id: undefined,
        hub_ht_cost: "",
        fois_origin_station_code: undefined,
        status: true,
      };

      this.setState({ newData: nData });
    }

    this.setState({ isModalVisible: status });
  };

  handleChange = (e, row, index, name, isPopup) => {
    e.target.name = name;

    var alphaRegex = /^[a-zA-Z]*$/;
    var numberRegex = /^[0-9.]+$/;
    let a;

    if (isPopup === false) {
      a = this.state.hubFactoryTableData;

      if (e.target.name === "fois_origin_station_code") {
        if (e.target.value === "") {
          a[row.key].fois_origin_station_code = "";
        } else if (e.target.value.match(alphaRegex)) {
          a[row.key].fois_origin_station_code = e.target.value.toUpperCase();
        }
      }

      if (e.target.name === "hub_ht_cost") {
        if (e.target.value === "") {
          a[row.key].hub_ht_cost = "";
        } else if (e.target.value.match(numberRegex)) {
          a[row.key].hub_ht_cost = e.target.value;
        }
      }

      if (e.target.name === "Hub_Name") {
        a[row.key].Hub_Name = e.target.value;
      }

      this.setState({ hubFactoryTableData: a });
    } else {
      a = this.state.newData;

      if (e.target.name === "fois_origin_station_code") {
        if (e.target.value === "") {
          a.fois_origin_station_code = "";
        } else if (e.target.value.match(alphaRegex)) {
          a.fois_origin_station_code = e.target.value.toUpperCase();
        }
      }

      if (e.target.name === "hub_ht_cost") {
        if (e.target.value === "") {
          a.hub_ht_cost = "";
        } else if (e.target.value.match(numberRegex)) {
          a.hub_ht_cost = e.target.value;
        }
      }

      if (e.target.name === "Hub_Name") {
        a.Hub_Name = e.target.value;
      }

      this.setState({ newData: a });
    }
  };

  handleDropdownChange = (value, row, target, index, optionlabel, isPopup) => {
    console.log("----", value, row)
    let a;
    if (isPopup === false) {
      a = this.state.hubFactoryTableData;
      if (target === "status") {
        a[row.key].status = Boolean(value);
      } else if (target === "Hub_Name") {
        a[row.key].hub_id = value;
        a[row.key].Hub_Name = optionlabel;
      }

      this.setState({ hubFactoryTableData: a });

    } else {
      a = this.state.newData;
      if (target === "status") {
        a.status = Boolean(value);
      } else if (target === "Hub_Name") {
        a.hub_id = value;
        a.Hub_Name = optionlabel;
      }
      this.setState({ newData: a });
    }
  };

  handleCancel = () => {
    this.setState({ isModalVisible: false });
  };

  handleEditChange = (row, index) => {
    this.setState({ rowData: row });
    let tempData = this.state.hubFactoryTableData.map((item) => {
      if (item.hub_id === row.hub_id) {
        return {
          ...item,
          isEdit: true,
        };
      } else {
        return item;
      }
    });

    this.setState({ hubFactoryTableData: tempData });
  };

  handleCancelClick = (rowData, index) => {
    let tempData = this.state.hubFactoryTableData.map((item) => {
      if (item.hub_id === rowData.hub_id) {
        return this.state.rowData;
      } else {
        return item;
      }
    });
    this.setState({ hubFactoryTableData: tempData });
  };

  render() {
    const userTableProps = {
      pagination: false,
      size: "default",
      bordered: true,
      scroll: { x: 200, y: window.innerHeight - 250 },
    };

    return (
      <div
        className="hub-master-container"
        style={{
          height: window.innerHeight - 85,
          marginTop: "-45px",
        }}
      >
        <div className="top-container">
          {/* <div className="hub-region-filter">
            <span
              style={{
                fontSize: "15px",
                marginTop: "5px",
                fontWeight: "600",
                marginLeft: "50px",
              }}
            >
              Branch&nbsp;
            </span>{" "}
            <Select

              showSearch
              optionFilterProp="children"
              className={"select-master-region"}
              mode="single"
              placeholder="Select Branch"
              value={this.state.selectedBranchValue}
              onChange={(value, props) =>
                handleRegionSelect(value, props)
              }
            >
              {this.state.selectedBranchList !== null && this.state.selectedBranchList.length &&
                this.state.selectedBranchList.map((item, idx) => (
                  <Option
                    value={item.branch_id}
                    key={item.branch_id}
                  >
                    {item.branch_name}
                  </Option>
                ))}
            </Select>
            <span
              style={{
                fontSize: "15px",
                marginTop: "5px",
                fontWeight: "600",
                marginLeft: "30px",
              }}
            >
              Hub&nbsp;
            </span>{" "}
            <Select

              showSearch
              optionFilterProp="children"
              className={"select-master-region"}
              mode="single"
              placeholder="Select Branch"
              value={this.state.selectedHubValue}
              onChange={(value, props) =>
                handleHubSelect(value, props)
              }
            >
              {this.state.filteredHubList !== null && this.state.filteredHubList.length &&
                this.state.filteredHubList.map((item, idx) => (
                  <Option
                    value={item.territory_id}
                    key={item.territory_id}
                  >
                    {item.territory_name}
                  </Option>
                ))}
            </Select>


          </div> */}

          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row-reverse",
              placeItems: "flex-end",
              marginRight: "25px",
              marginBottom: "10px",
            }}
          >
            <Search
              disabled={!this.state.isAdd}
              placeholder="Search"
              allowClear
              onChange={(e) => this.setState({ searchText: e.target.value })}
              style={{ width: "25%" }}
            />
            <Button
              className="add-master-button"
              style={{
                height: "25px",
                width: "70px",
                backgroundColor: "#0b133d",
                color: "white",
                paddingRight: 10,
              }}
              disabled={!canUserEdit(
                this.props.userData,
                null,
                FeatureCodes.MS_HUB_FACTORY_FRIEGHT_EDIT
              ) || !this.state.isAdd}
              onClick={() => this.setModalVisibility(true)}
            >
              &#10010; Add
            </Button>
          </div>
        </div>

        <div>
          <div
            style={{
              marginLeft: "25px",
              marginTop: "-8px",
              fontSize: "14px",
              color: "red",
              display: "flex",
              float: "left",
            }}
          > {getUserMSRBACMessage(this.props.messageAccess, FeatureCodes.MS_HUB_FACTORY_FRIEGHT_EDIT)}
          </div>
          <div
            style={{
              marginRight: "20px",
              marginTop: "-8px",
              fontSize: "15px",
              color: "#0B133D",
              display: "flex",
              float: "right",
            }}
          >Total number of records:&nbsp;
            <b>{this.state.hubFactoryTableData && this.setTableData().length}</b>
          </div>
        </div>

        <Spin
          spinning={this.state.isSpinnerOnLoad}
          size={"large"}
          tip="Loading..."
          style={{ alignSelf: "center", zIndex: 9999, marginTop: "20px" }}
        >
          <Modal
            className="add-master-modal"
            title={"Add Hub Rake H&T"}
            onCancel={this.handleCancel}
            footer={false}
            visible={this.state.isModalVisible}
            destroyOnClose={true}
          >
            <div className="master-form-container">
              <Form
                layout="horizontal"
                //   onValuesChange={onFormLayoutChange}
                size={"small"}
              // onSubmit={submitTableRowData(this.state.newData)}
              >
                <div className="form-top-container">
                  <div>
                    <div
                      className="checkbox-group1"
                      style={{
                        display: "inline-block",
                        width: "30%",
                        marginRight: 7,
                      }}
                    >
                      <Form.Item label="Hub">
                        <Select
                          showSearch
                          optionFilterProp="children"
                          className="remarks-select"
                          name="Hub_Name"
                          defaultValue={this.state.newData.hub_id}
                          value={this.state.newData.hub_id}
                          onSelect={(value, option) =>
                            this.handleDropdownChange(
                              value,
                              this.state.newData,
                              "Hub_Name",
                              -0,
                              option.props.children,
                              true
                            )
                          }
                        >
                          {this.state.primaryHubList &&
                            this.state.primaryHubList.length &&
                            this.state.primaryHubList.map((hubItem, idx) => (
                              <Option
                                key={hubItem.territory_id}
                                value={hubItem.territory_id}
                              >
                                {hubItem.territory_name}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>
                    </div>

                  </div>
                  <hr />
                  <div
                    className="checkbox-group1"
                    style={{
                      display: "inline-block",
                      width: "42%",
                      marginRight: 7,
                    }}
                  >
                    <Form.Item label="FOIS Origin Station Code">
                      <Input
                        style={{ marginRight: "2px" }}
                        maxLength={4}
                        value={this.state.newData.fois_origin_station_code}
                        name="fois_origin_station_code"
                        onChange={(e) =>
                          this.handleChange(
                            e,
                            this.state.newData,
                            -0,
                            "fois_origin_station_code",
                            true
                          )
                        }
                      />
                    </Form.Item>
                  </div>

                  <div
                    className="checkbox-group1"
                    style={{
                      display: "inline-block",
                      width: "42%",
                      marginRight: 7,
                    }}
                  >
                    <Form.Item label="Hub Rake H&T Cost (₹/MT)">
                      <Input
                        style={{ marginRight: "2px" }}
                        inputMode="number"
                        // maxLength={100}
                        value={this.state.newData.hub_ht_cost}
                        name="hub_ht_cost"
                        onChange={(e) =>
                          this.handleChange(
                            e,
                            this.state.newData,
                            -0,
                            "hub_ht_cost",
                            true
                          )
                        }
                      />
                    </Form.Item>
                  </div>
                  <div
                    className="form-top-container"
                    style={{
                      display: "inline-block",
                      width: "40%",
                      marginRight: 7,
                    }}
                  >
                    <Form.Item label="Status">
                      <Radio.Group
                        name="status"
                        value={this.state.newData.status ? 1 : 0}
                        onChange={(e, option) =>
                          this.handleDropdownChange(
                            e.target.value,
                            this.state.newData,
                            "status",
                            -0,
                            "",
                            true
                          )
                        }
                      >
                        <Radio value={1}>Active</Radio>
                        <Radio value={0}>Inactive</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </div>
                </div>

                <div className="form-bottom-container">
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={this.state.isSubmitted}
                      onClick={() =>
                        this.submitTableRowData(this.state.newData)
                      }
                    >
                      Submit
                    </Button>
                  </Form.Item>
                </div>
              </Form>
            </div>
          </Modal>
          <div
            className="table-container"
            style={{ maxHeight: "450px", margin: "6px 0px" }}
          >
            <Table
              {...userTableProps}
              columns={[
                {
                  title: "Hub",
                  dataIndex: "Hub_Name",
                  key: "Hub_Name",
                  width: 125,
                  filters: this.createFilters("Hub_Name"),
                  onFilter: (value, record) =>
                    record.Hub_Name.includes(value),
                  sortDirections: ["descend", "ascend"],
                  sorter: (a, b) => a.Hub_Name.localeCompare(b.Hub_Name),
                  /* render: (record, rowRecord) => {
                    return (
                      <>
                        <div
                          style={{ marginLeft: "-15px", marginRight: "-10px" }}
                        >
                          <Select
                            showSearch
                            optionFilterProp="children"
                            disabled={true}
                            className="remarks-select"
                            name="Hub_Name"
                            defaultValue={rowRecord.hub_id}
                            value={rowRecord.hub_id}
                            onSelect={(value, option) =>
                              this.handleDropdownChange(
                                value,
                                rowRecord,
                                "Hub_Name",
                                -0,
                                option.props.children,
                                false
                              )
                            }
                          >
                            {this.state.primaryHubList &&
                              this.state.primaryHubList.length &&
                              this.state.primaryHubList.map((hubItem, idx) => (
                                <Option
                                  key={hubItem.territory_id}
                                  value={hubItem.territory_id}
                                >
                                  {hubItem.territory_name}
                                </Option>
                              ))}
                          </Select>
                        </div>
                      </>
                    );
                  }, */
                },
                {
                  title: "FOIS Origin Station Code",
                  dataIndex: "fois_origin_station_code",
                  key: "fois_origin_station_code",
                  width: 110,
                  filters: this.createFilters("fois_origin_station_code"),
                  onFilter: (value, record) =>
                    record.fois_origin_station_code.includes(value),
                  sortDirections: ["descend", "ascend"],
                  sorter: (a, b) => a.fois_origin_station_code.localeCompare(b.fois_origin_station_code),
                  render: (record, rowRecord, index) => {
                    return (
                      <>
                        <div
                          style={{ marginLeft: "-15px", marginRight: "-10px" }}
                        >
                          <Input
                            disabled={!rowRecord.isEdit}
                            style={{ marginRight: "2px" }}
                            maxLength={4}
                            value={rowRecord.fois_origin_station_code}
                            name="fois_origin_station_code"
                            onChange={(e) =>
                              this.handleChange(
                                e,
                                rowRecord,
                                index,
                                "fois_origin_station_code",
                                false
                              )
                            }
                          />
                        </div>
                      </>
                    );
                  },
                },
                {
                  title: "Hub Rake H&T Cost (₹/MT)",
                  dataIndex: "hub_ht_cost",
                  key: "hub_ht_cost",
                  width: 110,
                  // filters: this.createFilters("hub_ht_cost"),
                  onFilter: (value, record) =>
                    record.hub_ht_cost.includes(value),
                  sortDirections: ["descend", "ascend"],
                  sorter: (a, b) => a.hub_ht_cost - b.hub_ht_cost,
                  render: (record, rowRecord, index) => {
                    return (
                      <>
                        <div
                          style={{ marginLeft: "-15px", marginRight: "-10px" }}
                        >
                          <Input
                            disabled={!rowRecord.isEdit}
                            style={{ marginRight: "2px" }}
                            // maxLength={100}
                            value={rowRecord.hub_ht_cost}
                            name="hub_ht_cost"
                            onChange={(e) =>
                              this.handleChange(
                                e,
                                rowRecord,
                                index,
                                "hub_ht_cost",
                                false
                              )
                            }
                          />
                        </div>
                      </>
                    );
                  },
                },
                {
                  key: "status",
                  title: "Status",
                  dataIndex: "status",
                  width: 70,
                  filters: this.createFilters("status"),
                  // onFilter: (value, record) =>
                  //   record.status === value,
                  render: (record, rowRecord, index) => {
                    return (
                      <>
                        <div style={{ marginLeft: "-15px", marginRight: "-40px" }}>
                          <Select
                            showSearch
                            optionFilterProp="children"
                            disabled={!rowRecord.isEdit}
                            defaultValue={
                              rowRecord.status === true ? 1 : 0
                            }
                            value={
                              rowRecord.status === true ? 1 : 0
                            }
                            onChange={(value, option) =>
                              this.handleDropdownChange(
                                value,
                                rowRecord,
                                "status",
                                index,
                                option.props.children,
                                false
                              )
                            }
                            style={{ width: "70%" }}
                          >
                            <Option key={1} value={1}>
                              {"Active"}
                            </Option>
                            <Option key={0} value={0}>
                              {"Inactive"}
                            </Option>
                          </Select>
                        </div>
                      </>
                    );
                  },
                },
                {
                  title: "Action",
                  dataIndex: "Submit",
                  key: "Submit",
                  width: 140,
                  render: (record, rowRecord, index) => {
                    return (
                      <>
                        <div style={{ display: "inline-flex", width: "100%" }}>
                          <Button
                            className={!canUserEdit(
                              this.props.userData,
                              null,
                              FeatureCodes.MS_HUB_FACTORY_FRIEGHT_EDIT
                            ) ? "disabledBtnClass" : "btnClass"}
                            disabled={!canUserEdit(
                              this.props.userData,
                              null,
                              FeatureCodes.MS_HUB_FACTORY_FRIEGHT_EDIT
                            )}
                            type="primary"
                            size={"small"}
                            style={{
                              marginLeft: 5,
                              alignSelf: "center",
                              color: "white",
                              borderRadius: 15,
                              padding: "0px 0px 2px",
                              height: 31,
                              backgroundColor: "#20346a",
                            }}
                            block
                            htmlType="submit"
                            onClick={() =>
                              rowRecord.isEdit
                                ? this.submitTableRowData(
                                  rowRecord,
                                  index,
                                  false
                                )
                                : this.handleEditChange(rowRecord, index)
                            }
                          >
                            {rowRecord.isEdit ? "Submit" : "Edit"}{" "}
                          </Button>

                          <Button
                            className={
                              !rowRecord.isEdit
                                ? "disabledBtnClass"
                                : "btnClass"
                            }
                            type="primary"
                            size={"small"}
                            style={{
                              marginLeft: 5,
                              alignSelf: "center",
                              color: "white",
                              borderRadius: 15,
                              padding: "0px 0px 2px",
                              height: 31,
                              backgroundColor: "#20346a",
                            }}
                            block
                            htmlType="submit"
                            disabled={!rowRecord.isEdit}
                            onClick={() =>
                              this.handleCancelClick(rowRecord, index)
                            }
                          >
                            Cancel
                          </Button>
                        </div>
                      </>
                    );
                  },
                },
              ]}
              dataSource={this.setTableData()}
            />
          </div>
        </Spin>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  userData: selectUserData,
  messageAccess: selectMSMessageRBAC,
});
export default connect(mapStateToProps)(HubRakeHTMaster);
//export default HubFactoryFrieghtMaster;
